import { getUserProfile, postUserProfile, changePassword as changePasswordService } from '../../services/AdminService';
import {formatError, formatSuccess} from '../../services/commonServices';
export const PORFILE_INITATED = 'PORFILE_INITATED';
export const PORFILE_LOADED = 'PORFILE_LOADED';
export const PORFILE_FAILED = 'PORFILE_FAILED';
export const LOADING_TOGGLE_ACTION = 'LOADING_TOGGLE_ACTION';
export function loadProfile() {
    return (dispatch) => {
        getUserProfile().then((response) => {
            dispatch(confirmedAction(response.data.data));
        })
        .catch((error) => {
            const errorMessage = formatError(error.response.data);
            dispatch(failedAction(errorMessage));
        });
    };
}
export function updateProfile(data) {
    return (dispatch) => {
        postUserProfile(data).then((response) => {
            dispatch(confirmedAction(response.data.data));
            formatSuccess('Profile', {message : 'Profile updated successfully'})
        })
        .catch((error) => {
           formatError(error.response.data);
        });
    };
}

export function changePassword(data) {
    return (dispatch) => {
        return changePasswordService(data)
            .then((response) => {
                dispatch(confirmedAction(response.data.data));
                formatSuccess('Password', { message: 'Password updated successfully' });
                return response;
            })
            .catch((error) => {
                if (error && error.response && error.response.data) {
                    formatError(error.response.data);
                } else {
                    formatError({ message: 'Failed to change password' });
                }
                throw error;
            });
    };
}
export function failedAction(data) {
    return {
        type: PORFILE_FAILED,
        payload: data,
    };
}

export function confirmedAction(data) {
    return {
        type: PORFILE_LOADED,
        payload: data,
    };
}
export function loadingToggleAction(status) {
    return {
        type: LOADING_TOGGLE_ACTION,
        payload: status,
    };
}
